/* eslint-disable */
import { v4 as uuidv4 } from "uuid";
import { createContext, useEffect, useState } from "react";
import { roundNumber } from "../utils/utils";
import { format } from "date-fns";

const CobranzaContext = createContext();

const mediosDeCobroOptions = [
	{
		id: "efectivo",
		label: "Efectivo",
	},
	{
		id: "tarjeta-debito",
		label: "Tarjeta de Débito",
	},
	{
		id: "tarjeta-credito",
		label: "Tarjeta de Crédito",
	},
	{
		id: "billetera-virtual",
		label: "Billetera Virtual",
	},
	{
		id: "transferencia-bancaria",
		label: "Transferencia Bancaria",
	},
	{
		id: "cheque",
		label: "Cheque",
	},
	{
		id: "obra-social",
		label: "Obra Social",
	},
	{
		id: "descuento-especial",
		label: "Descuento especial",
	},
	{
		id: "otro",
		label: "Otra forma de pago",
	},
];

const initialMedioDeCobroAction = {
	cu: "new",
	idMedioDeCobro: null,
};

const initialMedioDeCobro = {
	id: "",
	idMdc: "",
	tipoCobro: "",
	detalleMedioDeCobro: "",

	idTarjetaDebito: "",
	descripcionTarjetaDebito: "",
	porcentajeDescuentoTarjetaDebito: 0,

	idTarjetaCredito: "",
	descripcionTarjetaCredito: "",
	porcentajeDescuentoTarjetaCredito: 0,
	porcentajeInteresTarjetaCredito: 0,
	cantidadCuotasTarjetaCredito: 0,

	numeroLote: "",
	numeroCupon: "",

	idCuentaBancaria: "",
	bancoCuentaBancaria: "",
	comprobanteCuentaBancaria: "",

	idBilletera: "",
	descripcionBilletera: "",

	bancoCheque: "",
	numeroCheque: "",
	fechaCobroCheque: null,

	descripcionOtro: "",

	descripcionDescuentoEspecial: "",

	idObraSocial: "",
	descripcionObraSocial: "",
	idObraSocialPlan: "",
	descripcionObraSocialPlan: "",
	remitoObraSocial: "",
	idTipoDocumento: "",
	descripcionTipoDocumento: "",
	numeroDocumentoClienteObraSocial: "",
	nombreClienteObraSocial: "",
	apellidoClienteObraSocial: "",
	numeroBeneficiarioClienteObraSocial: "",

	importe: 0,
	importeDescuento: 0,
	importeRecargo: 0,
};

const initialMediosDeCobroTable = [];

const initialMediosDeCobro = [];

const mediosDeCobroConDescuento = [
	"efectivo",
	"tarjeta-debito",
	"tarjeta-credito",
	"billetera-virtual",
	"transferencia-bancaria",
];

// ################################################################################
// ################################################################################
// ################################################################################
//
const CobranzaProvider = ({ children }) => {
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);

	// arreglo de las gestiones de atencion seleccionadas para cobrar
	const [gestionesAtencion, setGestionesAtencion] = useState([]);
	// arreglo de las filas de productos de las gestiones de atencion seleccionadas para cobrar
	const [gestionesAtencionRows, setGestionesAtencionRows] = useState([]);

	const [totalGestionesAtencion, setTotalGestionesAtencion] = useState(0);
	const [totalPendienteCobro, setTotalPendienteCobro] = useState(0);
	const [totalCobrado, setTotalCobrado] = useState(0);
	const [restoACobrar, setRestoACobrar] = useState(0);

	const [totalPendienteCobroOriginal, setTotalPendienteCobroOriginal] = useState(0);
	const [totalPendienteCobroActual, setTotalPendienteCobroActual] = useState(0);

	const [expandedAccordionMediosDeCobro, setExpandedAccordionMediosDeCobro] = useState(false);

	const [medioDeCobroAction, setMedioDeCobroAction] = useState(initialMedioDeCobroAction);
	const [medioDeCobro, setMedioDeCobro] = useState(initialMedioDeCobro);
	const [mediosDeCobro, setMediosDeCobro] = useState(initialMediosDeCobro);
	const [mediosDeCobroTable, setMediosDeCobroTable] = useState(initialMediosDeCobroTable);

	const [valueACMedioDeCobro, setValueACMedioDeCobro] = useState(
		{
			id: "",
			label: "",
		});

	const [inputValueACMedioDeCobro, setInputValueACMedioDeCobro] = useState("");
	//
	// ################################################################################
	//
	useEffect(() => {

		generaRowsMediosDeCobroTable();
	}, [mediosDeCobro]);
	//
	// ################################################################################
	//
	useEffect(() => {

		calculaTotales();
	}, [gestionesAtencion, mediosDeCobroTable]);
	//
	// ################################################################################
	//
	const handleChangeMedioDeCobro = (e) => {
		setMedioDeCobro({
			...medioDeCobro,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleChangeFechaCobroCheque = (fecha) => {
		setMedioDeCobro({
			...medioDeCobro,
			fechaCobroCheque: fecha,
		});
	};
	//
	// ################################################################################
	//
	const limpiaMedioDeCobro = () => {
		setMedioDeCobroAction(initialMedioDeCobroAction);
		setMedioDeCobro(initialMedioDeCobro);
		setValueACMedioDeCobro({
			id: "",
			label: "",
		});
		setInputValueACMedioDeCobro("");
		setExpandedAccordionMediosDeCobro(false);
	};
	//
	// ################################################################################
	//
	const quitarMedioDeCobro = (parRow) => {

		// en mediosDeCobro quito la fila de este medio de cobro
		let _mediosDeCobro = mediosDeCobro.filter(
			(item) => item.idMdc !== parRow.idMdc && item.importe !== 0
		);

		let _mediosDeCobroArray = [];

		// restablezco el importe original y el importe de descuento de todos los medios de cobro registrados hasta ahora
		// y los agrego en un array
		_mediosDeCobro.forEach((mdcItem) => {
			mdcItem.importe = mdcItem.importeOriginal;
			mdcItem.importeDescuento = 0;
			_mediosDeCobroArray.push(mdcItem);
		});

		_mediosDeCobroArray = calculaImportesMDC(_mediosDeCobroArray);

		setMediosDeCobro(_mediosDeCobroArray);
	};
	//
	// ################################################################################
	//
	const calculaTotales = () => {

		let _totalGestionesAtencion = gestionesAtencion.reduce((acum, item) => {
			return acum + item.precio_venta_total + item.recargo;
		}, 0);
		setTotalGestionesAtencion(roundNumber(_totalGestionesAtencion));

		let _totalPendienteCobro = gestionesAtencion.reduce((acum, item) => {
			return acum + item.pendiente_pago_total + item.recargo;
		}, 0);
		setTotalPendienteCobro(roundNumber(_totalPendienteCobro));

		let _totalCobrado = mediosDeCobroTable.reduce((acum, item) => {
			return acum + item.importe + item.importeRecargo;
		}, 0);

		let _restoACobrar = _totalPendienteCobro - roundNumber(_totalCobrado);

		setTotalCobrado(_totalCobrado);
		setRestoACobrar(roundNumber(_restoACobrar));
	};
	//
	// ################################################################################
	//
	const agregaMedioDeCobro = (tipoCobro) => {

		let _medioDeCobro = {
			id: uuidv4(),
			idMdc: uuidv4(),
			tipoCobro: tipoCobro,
			detalleMedioDeCobro: generaDetalleDeMedioDeCobro(tipoCobro),

			// tarjeta de debito
			idTarjetaDebito: medioDeCobro.idTarjetaDebito,
			descripcionTarjetaDebito: medioDeCobro.descripcionTarjetaDebito,
			porcentajeDescuentoTarjetaDebito: medioDeCobro.porcentajeDescuentoTarjetaDebito,

			// tarjeta de credito
			idTarjetaCredito: medioDeCobro.idTarjetaCredito,
			descripcionTarjetaCredito: medioDeCobro.descripcionTarjetaCredito,
			porcentajeDescuentoTarjetaCredito: medioDeCobro.porcentajeDescuentoTarjetaCredito,
			porcentajeInteresTarjetaCredito: medioDeCobro.porcentajeInteresTarjetaCredito,
			cantidadCuotasTarjetaCredito: medioDeCobro.cantidadCuotasTarjetaCredito,
			numeroLote: medioDeCobro.numeroLote,
			numeroCupon: medioDeCobro.numeroCupon,

			// transferencia bancaria
			idCuentaBancaria: medioDeCobro.idCuentaBancaria,
			bancoCuentaBancaria: medioDeCobro.bancoCuentaBancaria,
			comprobanteCuentaBancaria: medioDeCobro.comprobanteCuentaBancaria,

			// billetera virtual
			idBilletera: medioDeCobro.idBilletera,
			descripcionBilletera: medioDeCobro.descripcionBilletera,

			// cheque
			bancoCheque: medioDeCobro.bancoCheque,
			numeroCheque: medioDeCobro.numeroCheque,
			fechaCobroCheque: medioDeCobro.fechaCobroCheque,

			// otro medio de cobro
			descripcionOtro: medioDeCobro.descripcionOtro,

			// descuento especial
			descripcionDescuentoEspecial: medioDeCobro.descripcionDescuentoEspecial,

			// obra social
			idObraSocial: medioDeCobro.idObraSocial,
			descripcionObraSocial: medioDeCobro.descripcionObraSocial,
			idObraSocialPlan: medioDeCobro.idObraSocialPlan,
			descripcionObraSocialPlan: medioDeCobro.descripcionObraSocialPlan,
			remitoObraSocial: medioDeCobro.remitoObraSocial,
			idTipoDocumento: medioDeCobro.idTipoDocumento,
			descripcionTipoDocumento: medioDeCobro.descripcionTipoDocumento,
			numeroDocumentoClienteObraSocial: medioDeCobro.numeroDocumentoClienteObraSocial,
			nombreClienteObraSocial: medioDeCobro.nombreClienteObraSocial,
			apellidoClienteObraSocial: medioDeCobro.apellidoClienteObraSocial,
			numeroBeneficiarioClienteObraSocial: medioDeCobro.numeroBeneficiarioClienteObraSocial,

			// para todos los medios de cobro
			importeOriginal: +medioDeCobro.importe,
			importe: +medioDeCobro.importe,
			importeDescuento: 0,
			importeRecargo: +medioDeCobro.importeRecargo,
		};

		console.log('------------------------------');
		console.log('im in agregaMedioCobro');
		console.log('_medioDeCobro');
		console.log(_medioDeCobro);
		console.log('------------------------------');

		// restablezco el importe original y el importe de descuento de todos los medios de cobro 
		// registrados hasta ahora y los agrego en un array
		let _mediosDeCobroArray = [];
		mediosDeCobro.forEach((mdcItem) => {
			mdcItem.importe = mdcItem.importeOriginal;
			mdcItem.importeDescuento = 0;
			_mediosDeCobroArray.push(mdcItem);
		});

		// agrego el nuevo medio de cobro que se esta registrando en el array
		_mediosDeCobroArray.push(_medioDeCobro);

		// calculaImportesMDC calcula, si corresponde, el importe de descuento de cada medio de cobro
		_mediosDeCobroArray = calculaImportesMDC(_mediosDeCobroArray);

		setMediosDeCobro(_mediosDeCobroArray);

		limpiaMedioDeCobro();
	};
	//
	// ################################################################################
	//
	const calculaImportesMDC = (parMediosDeCobroArray) => {

		let _totalGestionesAtencion = 0;

		gestionesAtencion.forEach((gaItem) => {
			gaItem.recargo = 0;
			_totalGestionesAtencion += gaItem.precio_venta_total;
		});

		// restablezco el importe pendiente de cobro actual a su importe original
		let _totalPendienteCobroActual = totalPendienteCobroOriginal;

		// restablezco los importes pendientes de cobro de las filas de las gas seleccionadas para cobrar
		gestionesAtencionRows.forEach((gaRowItem) => {
			gaRowItem.pendiente_pago = gaRowItem.pendiente_pago_original;
		});

		parMediosDeCobroArray.forEach((mdcItem) => {
			// para cada medio de cobro registrado

			let _tieneDescuento = tieneDescuento(mdcItem);
			let _tieneRecargo = tieneRecargo(mdcItem);

			// calculo porcentaje cobrado de este medio de cobro respecto del total pendiente de cobro actual
			let _porcentajeCobrado = roundNumber(mdcItem.importe * 100 / _totalPendienteCobroActual);

			if (!_tieneDescuento && !_tieneRecargo) {
				// si el medio de cobro no tiene ni descuento ni recargo

				updateImportePendienteCobro(_porcentajeCobrado, false, 0, 0);
			} else if (!_tieneDescuento && _tieneRecargo) {
				// si el medio de cobro no tiene descuento y si tiene recargo

				let _importeRecargo = roundNumber(mdcItem.importe * mdcItem.porcentajeInteresTarjetaCredito / 100);
				mdcItem.importeRecargo = _importeRecargo;

				gestionesAtencion.forEach((gaItem) => {
					// para cada ga seleccionada para cobrar

					let _porcentajeDelTotal = roundNumber(gaItem.precio_venta_total * 100 / _totalGestionesAtencion);
					let _recargoProporcional = roundNumber(_importeRecargo * _porcentajeDelTotal / 100);
					gaItem.recargo += _recargoProporcional;
				});

				updateImportePendienteCobro(_porcentajeCobrado, true, _totalGestionesAtencion, _importeRecargo);

			} else if (_tieneDescuento && !_tieneRecargo) {
				// si el medio de cobro tiene descuento y no tiene recargo

				console.log('------------------------------');
				console.log('im in tiene descuento y no tiene recargo');
				console.log('mdcItem');
				console.log(mdcItem);
				console.log('------------------------------');

				// obtengo el porcentaje de descuento de tarjeta de debito + de credito
				let _porcentajeDescuentoTarjetaDebitoCredito = mdcItem.porcentajeDescuentoTarjetaDebito + mdcItem.porcentajeDescuentoTarjetaCredito;

				// en las filas de las ga seleccionadas para cobrar actualizo importe de descuento proporcional a lo cobrado
				updateImporteDescuentoProporcional(_porcentajeCobrado, _porcentajeDescuentoTarjetaDebitoCredito);

				// de las filas de las ga seleccionadas para cobrar obtengo importe total proporcional de descuento
				let _totalDescuento = getTotalDescuentoProporcional();

				if (mdcItem.importe + _totalDescuento > _totalPendienteCobroActual) {
					// si el importe cobrado con este medio de cobro + el descuento correspondiente es mayor al total pendiente de cobro actual

					// de las filas de las ga seleccionadas para cobrar obtengo importe total de descuento
					_totalDescuento = getTotalDescuento();

					// asigno el nuevo valor al importe del medio de cobro
					mdcItem.importe = _totalPendienteCobroActual - _totalDescuento;

					if (mdcItem.importe < 0) {
						// si el nuevo importe asignado quedo negativo

						mdcItem.importe = _totalPendienteCobroActual;
						_totalDescuento = 0;
					}
					_porcentajeCobrado = 100;
				}
				mdcItem.importeDescuento = _totalDescuento;

				// en las filas de las ga seleccionadas para cobrar actualizo importe pendiente de cobro
				updateImportePendienteCobro(_porcentajeCobrado, false, 0, 0);
			}

			// actualizo el total pendiente de cobro actual
			_totalPendienteCobroActual = roundNumber(_totalPendienteCobroActual - mdcItem.importe - mdcItem.importeDescuento);
		});

		return parMediosDeCobroArray
	};
	//
	// ################################################################################
	//
	const updateImporteDescuentoProporcional = (parPorcentajeCobrado, parPorcentajeDescuentoTarjetaDebitoCredito) => {

		gestionesAtencionRows.forEach((gaRowItem) => {
			gaRowItem.descuento_total = roundNumber((gaRowItem.pendiente_pago * (gaRowItem.porcentaje_descuento + parPorcentajeDescuentoTarjetaDebitoCredito)) / 100);
			gaRowItem.descuento_proporcional = roundNumber(gaRowItem.descuento_total * parPorcentajeCobrado / 100);
		});
	};
	//
	// ################################################################################
	//
	const getTotalDescuentoProporcional = () => {
		let _totalDescuento = gestionesAtencionRows.reduce((acum, gaRowItem) => {
			return acum + gaRowItem.descuento_proporcional;
		}, 0);
		return _totalDescuento
	};
	//
	// ################################################################################
	//
	const getTotalDescuento = () => {
		let _totalDescuento = gestionesAtencionRows.reduce((acum, gaRowItem) => {
			return acum + gaRowItem.descuento_total;
		}, 0);
		return _totalDescuento
	};
	//
	// ################################################################################
	//
	const updateImportePendienteCobro = (parPorcentajeCobrado, parCalculaRecargo, parTotalGestionesAtencion, parImporteRecargo) => {

		gestionesAtencionRows.forEach((gaRowItem) => {

			if (parCalculaRecargo) {
				// si debo calcular recargo

				let _porcentajeDelTotal = roundNumber(gaRowItem.pendiente_pago_original * 100 / parTotalGestionesAtencion);
				let _recargoProporcional = roundNumber(parImporteRecargo * _porcentajeDelTotal / 100);
				gaRowItem.recargo = _recargoProporcional;
			}

			let _importePendienteCobro = 0;
			if (parPorcentajeCobrado !== 100) {
				_importePendienteCobro = roundNumber(gaRowItem.pendiente_pago - ((gaRowItem.pendiente_pago * parPorcentajeCobrado) / 100));
			}
			gaRowItem.pendiente_pago = _importePendienteCobro;
		});
	};
	//
	// ################################################################################
	//
	const generaRowsMediosDeCobroTable = () => {

		let _mediosDeCobroTable = [];

		mediosDeCobro.forEach((mdcItem) => {
			// para cada medio de cobro

			mdcItem.borrable = true;
			mdcItem.importe = roundNumber(mdcItem.importe);

			// genero la fila del descuento correspondiente a esta fila del medio de cobro

			let _descuento = {};
			if (mdcItem.importeDescuento > 0) {
				// si hay importe de descuento
				_descuento = {
					id: uuidv4(),
					idMdc: mdcItem.id,
					tipoCobro: "descuento-automatico",
					detalleMedioDeCobro: "Descuento Automatico",
					importe: roundNumber(mdcItem.importeDescuento),
					importeDescuento: 0,
					importeRecargo: 0,
					borrable: false,
				};
			}

			_mediosDeCobroTable.push(mdcItem);
			if (mdcItem.importeDescuento > 0) {
				_mediosDeCobroTable.push(_descuento);
			}
		});

		setMediosDeCobroTable(_mediosDeCobroTable);
	};
	//
	// ################################################################################
	//
	const generaDetalleDeMedioDeCobro = (tipoCobro) => {

		console.log('------------------------------');
		console.log('im in generaDetalleDeMedioDeCobro');
		console.log('medioDeCobro.fechaCobroCheque');
		console.log(medioDeCobro.fechaCobroCheque);
		console.log('------------------------------');

		let _detalleMedioDeCobro = "";
		if (tipoCobro === "efectivo") {
			_detalleMedioDeCobro = "";
		} else if (tipoCobro === "tarjeta-debito") {
			_detalleMedioDeCobro =
				medioDeCobro.descripcionTarjetaDebito +
				" - Lote " +
				medioDeCobro.numeroLote +
				" - Cupón " +
				medioDeCobro.numeroCupon;
		} else if (tipoCobro === "tarjeta-credito") {
			_detalleMedioDeCobro =
				medioDeCobro.descripcionTarjetaCredito +
				" - Lote " +
				medioDeCobro.numeroLote +
				" - Cupón " +
				medioDeCobro.numeroCupon;
		} else if (tipoCobro === "transferencia-bancaria") {
			_detalleMedioDeCobro =
				medioDeCobro.bancoCuentaBancaria +
				" - Comprobante " +
				medioDeCobro.comprobanteCuentaBancaria;
		} else if (tipoCobro === "billetera-virtual") {
			_detalleMedioDeCobro = medioDeCobro.descripcionBilletera;
		} else if (tipoCobro === "cheque") {
			_detalleMedioDeCobro =
				medioDeCobro.bancoCheque +
				" Nro " +
				medioDeCobro.numeroCheque +
				" Fecha " +
				format(medioDeCobro.fechaCobroCheque, "dd/MM/yyyy");
		} else if (tipoCobro === "otro") {
			_detalleMedioDeCobro = medioDeCobro.descripcionOtro;
		} else if (tipoCobro === "descuento-especial") {
			_detalleMedioDeCobro = medioDeCobro.descripcionDescuentoEspecial;
		} else if (tipoCobro === "obra-social") {
			_detalleMedioDeCobro =
				medioDeCobro.descripcionObraSocial +
				" - " +
				medioDeCobro.descripcionObraSocialPlan;
		}

		return _detalleMedioDeCobro;
	};
	//
	// ################################################################################
	//
	const tieneDescuento = (parMedioDeCobro) => {

		let _tieneDescuento = false;
		if (mediosDeCobroConDescuento.includes(parMedioDeCobro.tipoCobro)) {
			// si el medio de cobro esta entre los medios de cobro tienen descuento
			if (parMedioDeCobro.tipoCobro !== "tarjeta-credito") {
				// si el medio de cobro no es tarjeta de credito
				_tieneDescuento = true;
			} else {
				// si el medio de cobro es tarjeta de credito
				if (parMedioDeCobro.cantidadCuotasTarjetaCredito === 1) {
					_tieneDescuento = true;
				} else {
					if (parMedioDeCobro.porcentajeDescuentoTarjetaCredito > 0) {
						// si la tarjeta de credito tiene configurado un porcentaje de descuento
						_tieneDescuento = true;
					}
				}
			}
		}
		return _tieneDescuento;
	};
	//
	// ################################################################################
	//
	const tieneRecargo = (parMedioDeCobro) => {

		let _tieneRecargo = false;
		if (parMedioDeCobro.tipoCobro === "tarjeta-credito") {
			// si el medio de cobro es tarjeta de credito
			if (parMedioDeCobro.porcentajeInteresTarjetaCredito > 0) {
				// si la tc tiene interes
				_tieneRecargo = true;
			}
		}
		return _tieneRecargo;
	};
	//
	// ################################################################################
	//
	const prepararCobranzaObject = () => {

		// ------------------------------------------------------------------------------
		// preparo datos de usuario
		// usuario
		// rol del usuario
		// area

		// ------------------------------------------------------------------------------
		// preparo datos de las ga seleccionadas para cobrar

		let _gestionesAtencion = [];
		gestionesAtencion.forEach((item) => {

			let _gestionAtencion = {
				id_gc: item.id,
				precio_venta_total: roundNumber(item.precio_venta_total),
				pendiente_pago_total: roundNumber(item.pendiente_pago_total),
				recargo: roundNumber(item.recargo),
			};

			_gestionesAtencion.push(_gestionAtencion);
		});

		let _mediosDeCobro = [];
		mediosDeCobro.forEach((item) => {

			let _medioDeCobro = {}

			switch (item.tipoCobro) {
				case "efectivo":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "tarjeta-debito":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						id_tarjeta_debito: item.idTarjetaDebito,
						numero_lote: item.numeroLote,
						numero_cupon: item.numeroCupon,
						porcentaje_descuento_tarjeta_debito: item.porcentajeDescuentoTarjetaDebito,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "tarjeta-credito":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						id_tarjeta_credito: item.idTarjetaCredito,
						numero_lote: item.numeroLote,
						numero_cupon: item.numeroCupon,
						cantidad_cuotas_tarjeta_credito: item.cantidadCuotasTarjetaCredito,
						porcentaje_descuento_tarjeta_credito: item.porcentajeDescuentoTarjetaCredito,
						porcentaje_interes_tarjeta_credito: item.porcentajeInteresTarjetaCredito,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "transferencia-bancaria":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						id_cuenta_bancaria: item.idCuentaBancaria,
						comprobante_cuenta_bancaria: item.comprobanteCuentaBancaria,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "billetera-virtual":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						id_billetera: item.idBilletera,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "cheque":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						banco_cheque: item.bancoCheque,
						numero_cheque: item.numeroCheque,
						fecha_cobro_cheque: format(item.fechaCobroCheque, "yyyy/MM/dd"),
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "otro":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						descripcion_otro: item.descripcionOtro,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "descuento-especial":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						descripcion_descuento_especial: item.descripcionDescuentoEspecial,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;

				case "obra-social":

					_medioDeCobro = {
						tipo_cobro: item.tipoCobro,
						id_obra_social: item.idObraSocial,
						id_obra_social_plan: item.idObraSocialPlan,
						remito_obra_social: item.remitoObraSocial,
						id_tipo_documento: item.idTipoDocumento,
						numero_documento_cliente_obra_social: item.numeroDocumentoClienteObraSocial,
						nombre_cliente_obra_social: item.nombreClienteObraSocial,
						apellido_cliente_obra_social: item.apellidoClienteObraSocial,
						numero_beneficiario_cliente_obra_social: item.numeroBeneficiarioClienteObraSocial,
						importe: roundNumber(+item.importe),
						importe_descuento: roundNumber(+item.importeDescuento),
						importe_recargo: roundNumber(+item.importeRecargo),
					}
					break;
			}

			_mediosDeCobro.push(_medioDeCobro);
		});

		// ------------------------------------------------------------------------------
		// preparo datos de los medios de cobro

		let _cobranza = {
			ga_list: _gestionesAtencion,
			ga_rows_list: gestionesAtencionRows,
			mdc_list: _mediosDeCobro,
		};

		return _cobranza;
	};
	//
	// ################################################################################
	//
	const data = {
		message,
		setMessage,
		showMessage,
		setShowMessage,

		gestionesAtencion,
		setGestionesAtencion,
		gestionesAtencionRows,
		setGestionesAtencionRows,
		totalGestionesAtencion,
		setTotalGestionesAtencion,
		totalPendienteCobro,
		setTotalPendienteCobro,
		setTotalPendienteCobroOriginal,
		setTotalPendienteCobroActual,
		totalCobrado,
		setTotalCobrado,
		restoACobrar,
		setRestoACobrar,
		calculaTotales,

		expandedAccordionMediosDeCobro,
		setExpandedAccordionMediosDeCobro,

		handleChangeMedioDeCobro,
		handleChangeFechaCobroCheque,
		limpiaMedioDeCobro,
		medioDeCobroAction,
		setMedioDeCobro,
		medioDeCobro,
		agregaMedioDeCobro,
		mediosDeCobroTable,
		quitarMedioDeCobro,
		mediosDeCobroOptions,
		valueACMedioDeCobro,
		setValueACMedioDeCobro,
		inputValueACMedioDeCobro,
		setInputValueACMedioDeCobro,

		prepararCobranzaObject,
	};

	return (
		<CobranzaContext.Provider value={data}>{children}</CobranzaContext.Provider>
	);
};

export { CobranzaProvider };
export default CobranzaContext;